import React, { useCallback, useState } from 'react'
import fileDownload from 'js-file-download'

import { showErrorNotification } from '../../../common/helpers'
import { useDocumentTitle } from '../../../common/hooks/effects'

import { generateMiscTasksVerificationReport } from '../../rest'
import { MiscTasksVerificationReportForm } from '../forms'

const MiscTasksVerificationReportPage = () => {
  useDocumentTitle('Reports - Misc tasks verification')
  const [isGeneratingReport, setIsGeneratingReport] = useState(false)

  const generateReport = useCallback(
    async filters => {
      const { dateRange, ...miscTasksVerificationReportValues } = filters

      try {
        setIsGeneratingReport(true)
        const [startDateMoment, endDateMoment] = dateRange
        const reportReponse = await generateMiscTasksVerificationReport({
          startDate: startDateMoment.format('YYYY-MM-DD'),
          endDate: endDateMoment.format('YYYY-MM-DD'),
          ...miscTasksVerificationReportValues,
        })

        fileDownload(reportReponse.data, 'MiscTasksVerificationReport.csv')
        setIsGeneratingReport(false)
      } catch ({ response }) {
        showErrorNotification({
          message: 'Failed to generate report.',
          description: response.statusText,
        })
      }
    },
    [setIsGeneratingReport],
  )

  const handleSubmit = useCallback(filters => generateReport(filters), [
    generateReport,
  ])

  return (
    <MiscTasksVerificationReportForm
      onSubmit={handleSubmit}
      isGeneratingReport={isGeneratingReport}
    />
  )
}

export default MiscTasksVerificationReportPage
